export function replaceNonBreakingSpaces(text: string): string {
  const nbsp = new RegExp(/[\u00A0]/g);
  return text.replace(nbsp, ' ');
}
